import { render, staticRenderFns } from "./ExpenseSummary.vue?vue&type=template&id=37d8769c"
import script from "./ExpenseSummary.vue?vue&type=script&lang=js"
export * from "./ExpenseSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports